import React from "react";
import { withRouter } from "react-router-dom";
import "./StateTransition.css";
import { connect } from "react-redux";
import {
  updateExamInstitutionReviewFlags,
  updateInstitutionReviewFlags,
  updateReviewFlags
} from '../../redux-building-blocks/actions';

export class StepForm extends React.Component {

  handleNavigation = (event, value) => {
    if(!this.props.reviewFlag){
      switch(value){
        case 'personal':
          if(this.props.personalInfoFlag){
            this.props.updateExamInstitutionReviewFlags();
            this.props.history.push('/personal-information');
          }
          break;
        case 'exam':
          if(this.props.examDetailsInfoFlag){
            this.props.updateInstitutionReviewFlags();
            this.props.history.push('/exam-details');
          }
          break;
        case 'institution':
          if(this.props.institutionInfoFlag){
            this.props.updateReviewFlags();
            this.props.history.push('/institution-details');
          }
          break;
        default:
          break;
      }
    }
  }

  render() {
    
    return (
      <React.Fragment>
        
        <div className="containeritem w-100 d-flex d-sm-none d-md-none d-lg-none">
          
          <div className="breadcrumbitem">

            <span className={(this.props.pathname === "/personal-information") ? "stepitem current": (this.props.personalInfoFlag) ? "stepitem showcursor" : "stepitem" }>
              <span className="breadcrumb__inner">
                {(this.props.pathname === "/personal-information") ? <span className="breadcrumb__title" >1. Personal information</span> : <span className="breadcrumb__title" id="handleNavigationPersonal" onClick={(event) => this.handleNavigation(event, 'personal')}>1</span> }
              </span>
            </span> 
            
            <span className={(this.props.pathname === "/exam-details") ? "stepitem current": (this.props.examDetailsInfoFlag) ? "stepitem showcursor" : "stepitem"}>
              <span className="breadcrumb__inner">
              {(this.props.pathname === "/exam-details") ? <span className="breadcrumb__title" >2. Exam details</span> : <span className="breadcrumb__title" id="handleNavigationExam" onClick={(event) => this.handleNavigation(event, 'exam')}>2</span> }
              </span>
            </span> 

            <span className={(this.props.pathname === "/institution-details") ? "stepitem current": (this.props.institutionInfoFlag) ? "stepitem showcursor" : "stepitem"}>
              <span className="breadcrumb__inner">
                {(this.props.pathname === "/institution-details") ? <span className="breadcrumb__title">3. Institution details</span> : <span className="breadcrumb__title" id="handleNavigationInstitute" onClick={(event) => this.handleNavigation(event, 'institution')}>3</span> }
              </span>
            </span> 

          <span className={(this.props.pathname === "/review") ? "stepitem current": (this.props.reviewFlag) ? "stepitem showcursor" : "stepitem"}>
              <span className="breadcrumb__inner">
                {(this.props.pathname === "/review") ? <span className="breadcrumb__title">4. Review and confirm</span> : <span className="breadcrumb__title">4</span> }
              </span>
          </span>

          <span className={(this.props.pathname === "/acceptTerms") ? "stepitem current": (this.props.isTermsCrossed) ? "stepitem showcursor" : "stepitem"}>
              <span className="breadcrumb__inner">
                {(this.props.pathname === "/acceptTerms") ? <span className="breadcrumb__title">5. Accept terms</span> : <span className="breadcrumb__title">5</span> }
              </span>
          </span>

          <span className={(this.props.pathname === "/adyenPayment") ? "stepitem current": (this.props.isAdyen) ? "stepitem showcursor" : "stepitem"}>
              <span className="breadcrumb__inner">
              {(this.props.pathname === "/adyenPayment") ? <span className="breadcrumb__title">6. Pay</span> : <span className="breadcrumb__title">6</span> }
              </span>
          </span> 
          </div>
        </div>
        

        <div className="containeritem w-100 d-none d-sm-flex d-md-flex d-lg-flex">

          <div className="breadcrumbitem">

            <span className={(this.props.pathname === "/personal-information") ? "stepitem current": (this.props.personalInfoFlag && !this.props.reviewFlag) ? "stepitem showcursor" : "stepitem" }>
              <span className="breadcrumb__inner">
                <span className="breadcrumb__title" id="handleNavigationPersonal1" onClick={(event) => this.handleNavigation(event, 'personal')}>1. Personal information</span>	
              </span>
            </span>
            
            <span className={(this.props.pathname === "/exam-details") ? "stepitem current": (this.props.examDetailsInfoFlag && !this.props.reviewFlag) ? "stepitem showcursor" : "stepitem"}>
              <span className="breadcrumb__inner">
                <span className="breadcrumb__title" id="handleNavigationExam1"  onClick={(event) => this.handleNavigation(event, 'exam')}>2. Exam details</span>
              </span>
            </span> 
            
          <span className={(this.props.pathname === "/institution-details") ? "stepitem current": (this.props.institutionInfoFlag && !this.props.reviewFlag) ? "stepitem showcursor" : "stepitem"}>
              <span className="breadcrumb__inner">
                <span className="breadcrumb__title" id="handleNavigationInstitute1" onClick={(event) => this.handleNavigation(event, 'institution')}>3. Institution details</span>	
              </span>
          </span> 

          <span className={(this.props.pathname === "/review") ? "stepitem current": "stepitem"}>
              <span className="breadcrumb__inner">
                <span className="breadcrumb__title">4. Review and confirm</span>
              </span>
          </span>

          <span className={(this.props.pathname === "/acceptTerms") ? "stepitem current": (this.props.isTermsCrossed) ? "stepitem showcursor" : "stepitem"}>
              <span className="breadcrumb__inner">
                <span className="breadcrumb__title">5. Accept terms</span>
              </span>
          </span>

          <span className={(this.props.pathname === "/adyenPayment") ? "stepitem current": (this.props.isAdyen) ? "stepitem showcursor" : "stepitem"}>
              <span className="breadcrumb__inner">
                <span className="breadcrumb__title">6. Pay</span>
              </span>
          </span>  

        </div>
      </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return { personalInfoFlag: state.stateTransition.isPersonalInfoCrossed,
          examDetailsInfoFlag: state.stateTransition.isExamDetailsCrossed,
          institutionInfoFlag: state.stateTransition.isInstitutionDetailsCrossed,
          reviewFlag: state.stateTransition.isReviewAndConfirmCrossed,
          isTermsCrossed: state.stateTransition.isTermsCrossed,
          isAdyen: state.stateTransition.isAdyen };
};

const mapDispachToProps = {
    updateExamInstitutionReviewFlags,
    updateInstitutionReviewFlags,
    updateReviewFlags
};  

export default withRouter(connect(
  mapStateToProps,mapDispachToProps
)(StepForm));
